import { CHF } from 'lib/utilities'
import React from 'react'
import { Table } from 'semantic-ui-react'
import Fragment from 'react-dot-fragment'
import { I18n } from 'lib/i18n'

const style = {
  borderTopWidth: 0,
  paddingTop: 0,
  paddingBottom: 0,
}

const extraStyle = { ...style, opacity: 0.5 }

class CartRow extends React.PureComponent {
  render() {
    const { cartProduct, dealerVersion } = this.props
    return (
      <Fragment>
        <Table.Row verticalAlign="top">
          <Table.Cell style={style}>
            <nobr>{cartProduct.article_number}</nobr>
          </Table.Cell>
          <Table.Cell style={style} children={cartProduct.title_de} />
          <Table.Cell
            style={style}
            textAlign="right"
            children={`${cartProduct.quantity}x`}
          />

          {dealerVersion && (
            <Table.Cell
              style={extraStyle}
              textAlign="right"
              children={'Listenpreis'}
            />
          )}
          <Table.Cell
            style={dealerVersion ? extraStyle : style}
            textAlign="right"
            children={CHF(Number(cartProduct.price))}
          />
          <Table.Cell
            style={dealerVersion ? extraStyle : style}
            textAlign="right"
            children={CHF(cartProduct.quantity * +cartProduct.price)}
          />
        </Table.Row>
        {dealerVersion && (
          <Fragment>
            <Table.Row verticalAlign="top">
              <Table.Cell
                verticalAlign="top"
                style={style}
                children={
                  cartProduct.kind === 'specialItem' &&
                  !!cartProduct.special_item_kind &&
                  I18n.t(
                    `admin.product.specialitems.${cartProduct.special_item_kind}`
                  )
                }
              />
              <Table.Cell
                colSpan={3}
                verticalAlign="top"
                textAlign="right"
                style={extraStyle}
                children={`-${cartProduct.discount_percent}%`}
              />
              <Table.Cell
                verticalAlign="top"
                textAlign="right"
                style={extraStyle}
                children={CHF(
                  (-cartProduct.discount_percent * cartProduct.price) / 100
                )}
              />
              <Table.Cell
                verticalAlign="top"
                textAlign="right"
                style={extraStyle}
                children={CHF(
                  ((-cartProduct.discount_percent * cartProduct.price) / 100) *
                    cartProduct.quantity
                )}
              />
            </Table.Row>
            <Table.Row verticalAlign="top">
              <Table.Cell
                colSpan={5}
                verticalAlign="top"
                textAlign="right"
                style={style}
                children={CHF(+cartProduct.discounted_price)}
              />
              <Table.Cell
                verticalAlign="top"
                textAlign="right"
                style={style}
                children={CHF(
                  +cartProduct.discounted_price * cartProduct.quantity
                )}
              />
            </Table.Row>
          </Fragment>
        )}
      </Fragment>
    )
  }
}

export default CartRow



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CustomerCart/CartRow.jsx